/**
 * Одно правило на обе стороны: когда «не влезает» — это отказ, а когда догадка.
 *
 * Точный ответ про место у нас есть ровно в одном случае: каталог приёмника
 * пуст и прошлой работы сюда не было. Тогда записать придётся ровно вес
 * снимка, и арифметика сходится.
 *
 * Во всех остальных случаях мы считаем по ВЕРХНЕЙ ГРАНИЦЕ — как будто на диске
 * ничего нет, — и ошибаемся в разы. Измерено на боевых числах: свободно
 * 168 ГБ, «нужно» 247 ГБ, останется −79 ГБ; а дописать надо было единицы
 * гигабайт, потому что дерево уже лежало на месте.
 *
 * Поэтому неточное отрицание — предупреждение, а не запрет. Приёмник считает
 * место сам и в переполненный диск не пишет; его отказ основан на сверке
 * снимка с диском, наш — на предположении. Запрещать работу предположением
 * значит не беречь, а просто не давать работать.
 *
 * Правило живёт здесь, а не по копии на стороне: экран и сервер обязаны
 * отвечать одинаково. Разошлись бы — владелец видел бы открытую кнопку и
 * отказ по нажатию, то есть худшее из обоих ответов.
 */
export interface FitVerdict {
  /** Хватит ли места по нашему счёту. `null` — приёмник не сказал, сколько у него. */
  fits: boolean | null;
  /** Наш ответ точен (каталог пуст) или это верхняя граница. */
  fitsCertain: boolean;
}

/** Запрещать ли запуск из-за места. */
export function blocksStart(plan: FitVerdict): boolean {
  return plan.fits === false && plan.fitsCertain;
}
